var render = function render(_c,_vm){return _c('froala-view',_vm._g(_vm._b({attrs:{"value":_vm.props.value}},'froala-view',_vm.attrs,false),_vm.listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }